import { render, staticRenderFns } from "./ShoeArea.vue?vue&type=template&id=71041f8e&"
import script from "./ShoeArea.vue?vue&type=script&lang=js&"
export * from "./ShoeArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports